/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListColumnPresetsQueryResponse,
  ListColumnPresetsQueryParams,
} from '../types/ListColumnPresets'

function getListColumnPresetsUrl() {
  const res = { method: 'GET', url: `/api/v1/column-presets/` as const }
  return res
}

/**
 * @summary List column presets visible to the current user
 * {@link /api/v1/column-presets/}
 */
export async function listColumnPresets(
  params?: ListColumnPresetsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListColumnPresetsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListColumnPresetsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
